import { createRouter, createWebHistory } from '@ionic/vue-router'
import { RouteRecordRaw } from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import { supabase } from '@/services/supabase'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('@/views/AuthPage.vue')
  },
  {
    path: '/trip/:id',
    name: 'Trip',
    component: () => import('@/views/TripPage.vue'),
    props: true
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/ProfilePage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/SettingsPage.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/views/PrivacyPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/vehicles',
    name: 'Vehicles',
    component: () => import('@/views/VehiclesPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: () => import('@/views/StatisticsPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('@/views/TripHistoryPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/shared/:token',
    name: 'SharedTrip',
    component: () => import('@/views/SharedTripPage.vue'),
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

function blurActiveElement() {
  const activeElement = getDeepActiveElement(document.activeElement)

  if (activeElement instanceof HTMLElement) {
    activeElement.blur()
  }
}

function getDeepActiveElement(element: Element | null): Element | null {
  if (!element) {
    return null
  }

  const shadowRoot = element.shadowRoot
  if (shadowRoot?.activeElement) {
    return getDeepActiveElement(shadowRoot.activeElement)
  }

  return element
}

// Navigation guard for protected routes
router.beforeEach(async (to, from, next) => {
  blurActiveElement()

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  
  if (requiresAuth) {
    // Check if user is authenticated via Supabase
    try {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) {
        next('/auth')
        return
      }
    } catch (error) {
      console.error('Auth check failed:', error)
      next('/auth')
      return
    }
  }
  
  next()
})

export default router